export function labelData(label, data) {
    if (data === null || data === undefined) return null;
    const newData = {};
    for (let i = 0; i < label.length; i++) {
      newData[label[i]] = data[i];
    }
    return newData;
  }